import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const CommonLayout = ({ children }) => {
  return (
    <Container>
      <Row className="justify-content-center">
        <Col sm="12">
          {children}
        </Col>
      </Row>
    </Container>
  );
};

export default CommonLayout;
